/* eslint-disable arrow-body-style */
import React, { useState } from 'react';
import './index.scss';
import EditIcon from '../EditIcon';
import EditModal from '../EditModal';
import { editReportSummary } from '@home/services/studio';
import { useIntl, useParams } from 'umi';
import { notification } from 'tea-component';
import { IDomEditor } from '@wangeditor/editor';

interface IProps {
  className: string;
  style: React.CSSProperties;
  data?: {
    gptSummaryData:{
      id: number | undefined;
      gpt_summary: string;
    };
  };
  filter: any;
  gameInfo?: any;
  refresh?:() => void;
  // 是否隐藏编辑按钮
  hideRightSlot?: boolean;
}

export default function EditGpt(props: IProps) {
  const { className, style, data, filter, gameInfo,refresh } = props || {};
  const gptSummaryData = data?.gptSummaryData || {};
  const { formatMessage } = useIntl();
  const [showModal, setShowMore] = useState(false);
  const { studioId } = useParams() || {} as any;
  const { date_type: dateType, startTime, endTime } = filter || {};

  // 确认按钮点击事件，编辑gpt 数据
  const handleSubmit = (data: string) => {
    let params;
 
    if (gptSummaryData?.id) {
      params = {
        id: gptSummaryData?.id,
        studio_code: studioId,
        unified_id: gameInfo?.edition_unified_id,
        period: dateType,
        gpt_summary: data || '',
        start_date: startTime,
        end_date: endTime, 
      };
    } else {
      params = {
        id: 0,
        studio_code: studioId,
        unified_id: gameInfo?.edition_unified_id,
        period: dateType,
        start_date: startTime,
        end_date: endTime, 
        module: 'gpt_summary',
        gpt_summary: data || '',
      };
    }
    editReportSummary?.(params).then(() => {
      refresh?.();
      notification.success({
        description: formatMessage({id: 'dbh_studio_funcom_edit_modal_success'}),
        // className: isHaveSameName,
        duration: 1000,
      });
      setShowMore(false);
    }).catch(() => {
      notification.success({
        description: formatMessage({id: 'dbh_studio_funcom_edit_modal_failed'}),
        // className: isHaveSameName,
        duration: 1000,
      });
    });

  };

  const changeShowModal = () => {
    setShowMore(!showModal);
  };

  // 自定义粘贴，gpt不粘贴图片，粘贴图片报错处理
  const customPaste = (editor: IDomEditor, e: ClipboardEvent) => {
    const {clipboardData} = e;
  
    if (!clipboardData) {
      return true; // 如果没有 clipboardData，返回 false
    }
    
    // 检查 clipboardData.items
    for (let i = 0;i < clipboardData.items.length;i++) {
      const item = clipboardData.items[i];
      if (item.type.startsWith('image/')) {
        console.log('Detected image in clipboardData.items:', item.type);
        return false; // 忽略图片
      }
    }
    
    // 检查 clipboardData.files
    for (let i = 0;i < clipboardData.files.length;i++) {
      const file = clipboardData.files[i];
      if (file.type.startsWith('image/')) {
        console.log('Detected image in clipboardData.files:', file.type);
        return false; // 忽略图片
      }
    }
    
    return true; // 默认返回 false，表示忽略粘贴内容
  };

  return (
    <div className={className} style={style}>
      <EditIcon onClick={changeShowModal} />
      <EditModal
        title={formatMessage({id: 'dbh_studio_funcom_edit_modal_gpt_title'})}
        closeModal={changeShowModal}
        isVisible={showModal}
        customPaste={customPaste}
        key={gptSummaryData?.gpt_summary}
        data={gptSummaryData?.gpt_summary}
        handleSubmit={handleSubmit}
        handleCancel={showModal}
        handelCancel={changeShowModal}
        // 解决重新打开modal编辑器报错问题，editor未实例化
        destroyOnClose={false}
      />
    </div>
  );
}
